import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    serviceType: [],
    servicePackage: [],
    bikeType: [],
    gearSystem:[],
    branchList: [],
    brandList:[],
    serviceRequired: [
      // {
      //   label: "AMC",
      //   id: 1,
      // },
      // {
      //   label: "Normal",
      //   id: 2,
      // },
    ],
    offerList: [
      // {
      //   label: "AMC-1 year",
      //   id: 1,
      // },
      // {
      //   label: "SPORTS-1 year",
      //   id: 2,
      // },
    ],
    addresslist: [],
    bikelist: [],
    addressTypeList: [],
    stateList: [],
    cityList: [],
    superStarsList:[],
    slotDates:[],
    slotTimeList:[],
    branchDetail:null,
    availableTechnicianData:null,
    slotsAvailable :[]
}

export const createRequestDetailsAction = createSlice({
  name: 'createRequestDetails',
  initialState,
  reducers: {
    setServiceType: (state, action) => {
      state.serviceType = action.payload
    },
    setBranchDetail: (state, action) => {
      state.branchDetail = action.payload
    },
    setServicePackage: (state, action) => {
      state.servicePackage = action.payload
    },
    setBikeType: (state, action) => {
      state.bikeType = action.payload
    },
    setGearSystem:(state,action)=>{
      state.gearSystem = action.payload
    },
    setBrand:(state,action)=>{
      state.brandList = action.payload
    },
    setBikelist: (state, action) => {
      state.bikelist = action.payload
    },
    setBranchList: (state, action) => {
      state.branchList = action.payload
    },
    setAddresslist: (state, action) => {
      state.addresslist = action.payload
    },
    setAddressTypeList: (state, action) => {
      state.addressTypeList = action.payload
    },
    setStateList: (state, action) => {
      state.stateList = action.payload
    },
    setCityList: (state, action) => {
      state.cityList = action.payload
    },
    setServiceRequiredList: (state, action) => {
      state.serviceRequired = action.payload
    },
    setOfferList: (state, action) => {
      state.offerList = action.payload
    },
    setSuperStarList: (state, action) => {
      state.superStarsList = action.payload
    },
    setSlotDates:(state,action)=>{
      state.slotDates = action.payload
    },
    setSlotTime:(state,action)=>{
      //console.logaction.payload,'frrrrrrrrrrrrrrrrrrrrr')
      state.slotTimeList = action.payload
    },
    setAvailableTechnicianData:(state,action)=>{
      state.availableTechnicianData = action.payload
    },
    setAvailableSlots:(state,action)=>{
      state.slotsAvailable = action.payload
    }
  },
})

export const { setServiceType,setServicePackage,setBikeType,setBikelist,setBranchList, setAddresslist,setAddressTypeList,setStateList,setCityList,setServiceRequiredList,setOfferList,setSuperStarList,setGearSystem,setBrand,setSlotDates,setSlotTime,setBranchDetail,setAvailableTechnicianData,setAvailableSlots} = createRequestDetailsAction.actions

export default createRequestDetailsAction.reducer